export const POST_NEWSLETTER_BEGIN = "POST_NEWSLETTER_BEGIN";
export const POST_NEWSLETTER_SUCCESS = "POST_NEWSLETTER_SUCCESS";
export const POST_NEWSLETTER_ERROR = "POST_NEWSLETTER_ERROR";
